module.exports = __webpack_public_path__ + "static/media/dairy-expression.c29752eb.jpg";